import React from "react";

interface TriangleTexturedProps {
  color?: string;
  className?: string;
}

export const TriangleTextured: React.FC<TriangleTexturedProps> = ({
  color = "#28834C",
  className = "TriangleTextured",
}) => {
  return (
    <>
      <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" fill="none">
        <g clip-path="url(#clip0_4248_18892)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.51753 13.4375C1.8726 12.7868 1.5691 12.0431 1.37942 11.2529C1.22767 10.5092 1.2656 9.71902 1.22767 8.97532C1.18973 7.53441 1.15179 6.04702 1.07592 4.6061C1.03798 3.30463 0.924167 2.00317 0.88623 0.701696C0.88623 0.515773 1.00004 0.236887 1.07592 0.190406C1.22767 0.143925 1.49323 0.143924 1.64498 0.283367C2.40372 0.88762 3.12453 1.49187 3.84534 2.14261C4.60409 2.83982 5.55252 3.25815 6.12158 4.28074C6.31126 4.65258 6.72857 4.83851 7.03207 5.07091C7.63907 5.44276 8.01844 6.3259 8.77719 6.51183C8.96688 6.55831 9.08069 6.93015 9.27037 7.16256C9.15656 7.95274 8.70131 8.2781 8.09432 8.41755C7.94257 8.46403 7.63907 8.46403 7.60113 8.55699C7.33557 9.62605 6.42508 9.71902 5.85602 10.3233C5.05933 11.2064 4.14884 11.9501 3.31422 12.7403C3.08659 12.9727 2.82103 13.1586 2.51753 13.4375Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_4248_18892">
            <rect width="13.2749" height="8.38414" fill="white" transform="translate(0.88623 13.4375) rotate(-90)"/>
          </clipPath>
        </defs>
      </svg>
    </>
  );
}; 